import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingHDPhotoConverterConfig } from '@/data/landingConfig/landingHDPhotoConverterConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_HDPhotoConverter } from './schemaObject';

const HDPhotoConverter = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_HDPhotoConverter} />
			<LandingTemplate
				data={landingHDPhotoConverterConfig}
				funnelLinkService={GenerateLandingLinkService.funnelImageUpscaleV3()}
			/>
		</>
	);
};

export default HDPhotoConverter;
